<template>
    <feature feature-key="calendar" sub-key="user-setting" class="my-24">
        <h2 v-if="!$slots.title" class="first-letter:uppercase font-semibold text-heading-1 mb-16">
            {{ $t('calendar.sync_title') }}
        </h2>
        <slot name="title"></slot>

        <div class="flex items-center space-x-24">
            <calendar-sync :sync="sync"></calendar-sync>

            <button class="bg-white inline-flex items-center pl-14 pr-12 py-8 rounded border border-primary-20 text-primary hover:bg-primary-5"
                    role="button"
                    @click.prevent="editCalendarSync = true"
            >
                <svg-icon class="mr-10 -ml-2 w-16 h-16" type="edit"/>
                {{ $t('general.edit') }}
            </button>
        </div>

        <popup-modal-confirm
            v-if="editCalendarSync"
            :working="performingAutoSyncRequest"
            confirm-button="success"
            message="Wijzig hier de synchronisatie van afspraken met je persoonlijke kalender."
            title="Bewerk synchronisatie afspraak"
            @close="editCalendarSync = false"
            @confirm="saveAutoSync"
        >
            <div :class="autosync ? 'border-secondary font-semibold' : 'border-transparent'"
                 class="bg-primary-5 hover:border-primary-5 p-12 cursor-pointer flex justify-between items-center border transition-all my-24"
            >
                <checkbox v-model="autosync" :value="sync" @change="handleChange">
                    {{ $t('calendar.auto_sync_event') }}
                </checkbox>
            </div>

            <checkbox v-model="generalSync">
                {{ $t('calendar.save_autosync') }}
            </checkbox>
        </popup-modal-confirm>
    </feature>
</template>

<script>
import * as users from '../../services/UserService';
import User from '../../models/User';
import {mapState} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useAuthenticationStore} from '../../state/modules/authentication';
import SvgIcon from './SvgIcon.vue';
import Feature from '../Feature.vue';
import CalendarSync from './CalendarSync.vue';
import PopupModalConfirm from './PopupModalConfirm.vue';
import Checkbox from '../forms/Checkbox.vue';
import Toggle from '../forms/Toggle.vue';

export default {
    components: {Toggle, Checkbox, PopupModalConfirm, CalendarSync, Feature, SvgIcon},
    props: {
        sync: {
            type: Boolean,
            required: true,
        },
    },
    data: function () {
        return {
            autosync: true,
            generalSync: false,
            editCalendarSync: false,
            performingAutoSyncRequest: false,
        };
    },
    computed: {
        ...mapState(useAuthenticationStore, ['currentUserId']),
        user() {
            return useRepo(User).find(this.currentUserId);
        },
    },
    methods: {
        handleChange() {
            this.$emit('input', this.autosync);
        },
        saveAutoSync() {
            if (!this.generalSync) {
                this.editCalendarSync = false;
                return;
            }

            this.performingAutoSyncRequest = true;

            users.update(this.currentUserId, {
                data: {attributes: {cronofy_auto_sync: this.autosync}},
            }).then(result => {
                useRepo(User)
                    .whereId(this.currentUserId)
                    .update({cronofy_auto_sync: this.autosync});

                this.performingAutoSyncRequest = false;
                this.editCalendarSync = false;
            });
        },
    },
    mounted() {
        //Sync for this event
        this.autosync = this.sync;
    },
};
</script>
